import { FC } from 'react';
import { UiInput, UiInputView } from '@nx-frontend/shared/ui/input';
import { UiTextArea } from '@nx-frontend/shared/ui/textarea';
import { AIAgentInputField, AIAgentTextFieldType } from '@nx-frontend/shared/types/ai-agents';

export const AgentInputText: FC<{
  field: AIAgentInputField;
  onChange: (value: string | File) => void;
  showError?: boolean;
  errorText?: string;
}> = ({ field, onChange, showError = false }) => {
  let input: JSX.Element;

  if (field.textFieldType === AIAgentTextFieldType.SINGLE) {
    input = (
      <UiInput
        view={UiInputView.LABEL_TOP}
        value={''}
        placeholder={field.placeholder}
        id={field.id}
        labelSmallGrey={true}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        error={showError}
        errorText={showError ? 'This field is required' : undefined}
      />
    );
  } else {
    input = (
      <UiTextArea
        value={''}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        placeholder={field.placeholder}
        error={showError}
        errorText={showError ? 'This field is required' : undefined}
      />
    );
  }

  return (
    <div className="flex flex-col mt-4">
      {field.description && <div className="text-[16px] text-neutral-500 mb-2">{field.description}</div>}
      <label className="text-[#5C6061] text-xs" htmlFor={field.id}>
        {field.label} {field.required && <span className="text-red-500">*</span>}
      </label>
      {input}
    </div>
  );
};
